/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgencyDto } from '../../models/agency-dto';

export interface ApiAgencyGuidGet$Params {
  guid: string;
  'api-version'?: string;
}

export function apiAgencyGuidGet(http: HttpClient, rootUrl: string, params: ApiAgencyGuidGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgencyDto>> {
  const rb = new RequestBuilder(rootUrl, apiAgencyGuidGet.PATH, 'get');
  if (params) {
    rb.path('guid', params.guid, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgencyDto>;
    })
  );
}

apiAgencyGuidGet.PATH = '/api/agency/{guid}';
